import React from "react";
import TooltipWrapper from "../utils/TooltipWrapper";

const ATTENDANCE_LEGEND = [
  { code: "P", key: "present", label: "Present" },
  { code: "HD", key: "halfDay", label: "Half Day" },
  { code: "HO", key: "holiday", label: "Holiday" },
  { code: "A", key: "absent", label: "Absent" },
  { code: "WO", key: "weekOff", label: "Week Off" },
  { code: "LA", key: "leave", label: "Leave" },
];

const AttendanceCountSummary = ({ summary, style = {} }) => {
  if (!summary) {
    return null;
  }

  return (
    <small style={{ color: "#666", fontSize: "11px", ...style }}>
      {ATTENDANCE_LEGEND.map(({ code, key, label }, index) => {
        const count = summary[key] ?? 0;

        return (
          <React.Fragment key={code}>
            {index > 0 && " | "}
            <TooltipWrapper tooltipText={`${label}: ${count}`}>
              <span style={{ cursor: "help" }}>
                {code}: {count}
              </span>
            </TooltipWrapper>
          </React.Fragment>
        );
      })}
    </small>
  );
};

export default AttendanceCountSummary;
